import { setOptInStatus } from "../api.js";

export async function optIn(eventId, { dancerId, occurrenceDate }) {
  return setOptInStatus(eventId, { dancerId, occurrenceDate, optedIn: true });
}
